module.exports = __webpack_public_path__ + "static/media/Preterite-ve-Imperfect.311176c2.jpg";